const passwordToggleInit = () => {
  const passwords = document.querySelectorAll('[data-password]');
  if (passwords) {
    passwords.forEach(password => {
      const passwordInput = password.querySelector('[data-password-input]');
      const passwordToggler = password.querySelector('[data-password-toggle]');
      
    });
  }
};

export default passwordToggleInit;
